
export interface IServerWideTask {
    excludedDatabases?: string[];
}